module.exports = __webpack_public_path__ + "img/companies-register.85b407ce.png";